import { InjectionToken } from '@angular/core';
import { SharedEnvironmentConfig } from '../models';

export const SHARED_ENVIRONMENT_CONFIG = new InjectionToken<SharedEnvironmentConfig>('SHARED_ENVIRONMENT');
export const IS_CROWNDESK = new InjectionToken<boolean>('IS_CROWNDESK', { factory: () => false });

/** Brand suffix appended to every browser tab title, e.g. `Ontvangsten | CrownBase`. */
export const APP_TITLE_SUFFIX = new InjectionToken<string>('APP_TITLE_SUFFIX', { factory: () => 'CrownBase' });
export const ENERGY_LABEL_PIMS_ID = new InjectionToken<string>('ENERGY_LABEL_PIMS_ID', {
  factory: () => '47bdd8d6-6892-4bb3-935d-c536e4b0cf1d',
});
